import * as auth0 from 'auth0-js';

class AuthenticationService {
  private readonly webAuth: auth0.WebAuth;
  private idToken?: string;
  private tokenExpiry?: Date;
  private profile?: any;

  public constructor() {
    this.webAuth = new auth0.WebAuth({
      domain: 'marolt.eu.auth0.com',
      clientID: 'kVl20upeXpml6Jn5jMSjHv75Qy7pXwIG',
      redirectUri: `${window.location.origin}/auth-callback`,
      responseType: 'id_token',
      scope: 'openid profile email',
    });
  }

  public login(): void {
    this.webAuth.authorize();
  }

  public handleAuthentication(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.webAuth.parseHash((error, result: any) => {
        if (error) {
          console.error(`Error while parsing login token!`, error);
          reject(error);
        } else {
          this.localLogin(result);
          resolve(result);
        }
      });
    });
  }

  public renewTokens(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (localStorage.getItem('id_token') === null) {
        return reject('Not logged in!');
      }

      this.webAuth.checkSession({}, (error, result) => {
        if (error) {
          reject(error);
        } else {
          this.localLogin(result);
          resolve(result);
        }
      });
    });
  }

  public logout(): void {
    localStorage.removeItem('id_token');
    localStorage.removeItem('profile');
    localStorage.removeItem('id_token_expiration');

    this.idToken = undefined;
    this.tokenExpiry = undefined;
    this.profile = undefined;

    this.webAuth.logout({
      returnTo: window.location.origin,
    });
  }

  public authenticationDetails(): any | null {
    if (this.idToken === undefined) {
      const idToken = localStorage.getItem('id_token');
      this.idToken = idToken !== null ? idToken : undefined;
    }
    if (this.profile === undefined) {
      const profile = localStorage.getItem('profile');
      this.profile = profile !== null ? JSON.parse(profile) : undefined;
    }
    if (this.tokenExpiry === undefined) {
      const tokenExpiry = localStorage.getItem('id_token_expiration');
      this.tokenExpiry = tokenExpiry !== null ? new Date(parseInt(tokenExpiry, 10)) : undefined;
    }

    if (this.idToken !== undefined && Date.now() < (this.tokenExpiry as Date).getTime()) {
      return {
        idToken: this.idToken,
        idTokenPayload: this.profile,
      };
    }

    return null;
  }

  private localLogin(authResult: any): void {
    this.idToken = authResult.idToken;
    this.profile = authResult.idTokenPayload;

    this.tokenExpiry = new Date(this.profile.exp * 1000);

    localStorage.setItem('id_token', this.idToken as string);
    localStorage.setItem('profile', JSON.stringify(this.profile));
    localStorage.setItem('id_token_expiration', this.tokenExpiry.getTime().toString());
  }

}

export const authService = new AuthenticationService();
